import React from 'react';
import '../App.css'
import CarouselContainer from '../components/Home/CarouselCont'
import Buttons from '../components/Home/Buttons'
import StickyHeadTable from '../components/Home/Table'

// import './Home.css'

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';


function Home() {

    return (
        <Box>
            <Grid container spacing={2} style={{ overflowX: 'hidden' }}>
                <Grid item xs={6} sm={10} md={8} lg={8}>
                    <div className="containerCarousel">
                        <CarouselContainer></CarouselContainer>
                    </div>
                </Grid>
                <Grid item xs={2} sm={2} md={4} lg={4} >
                    <div className="containerButtons">
                        <Buttons></Buttons>
                    </div>
                </Grid>
                <Grid item xs={6} sm={12} md={12} lg={12} >
                    <div className="containerTable">
                        <StickyHeadTable></StickyHeadTable>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}
export default Home;
